import { paths } from '@shared/config/paths';

/** Libellés lisibles par segment d'URL. */
const SEGMENT_LABELS: Record<string, string> = {
  dashboard: 'Tableau de bord',
  receipts: 'Tickets',
  new: 'Nouveau',
  expenses: 'Dépenses',
  analytics: 'Analyses',
  ai: 'Analyses IA',
  settings: 'Paramètres',
  help: 'Aide',
};

export interface Crumb {
  label: string;
  to?: string;
}

/** Construit le fil d'Ariane à partir du chemin courant. */
export function breadcrumbsFor(pathname: string): Crumb[] {
  if (pathname === paths.home || pathname === paths.dashboard) return [];

  const segments = pathname.split('/').filter(Boolean);
  return segments.map((segment, index) => {
    const to = `/${segments.slice(0, index + 1).join('/')}`;
    const label = SEGMENT_LABELS[segment] ?? segment;
    const isLast = index === segments.length - 1;
    return isLast ? { label } : { label, to };
  });
}
